import * as React from "react";
import { FormService } from "../services/FormService";
import ReactHtmlParser from "react-html-parser";
import { StringHelpers } from '../helpers/StringHelpers';

export interface SidebarContentProps {
}

export interface SidebarContentState {
  values: any;
  form: string;
}

export class SidebarContent extends React.Component<SidebarContentProps> {

  state = {
    values : undefined,
    form : ""
  };

  componentDidMount() {
    FormService.registerRelatedDataCallback(this.onFormUpdate);
  }

  componentWillUnmount() {
    FormService.registerRelatedDataCallback(undefined);
  }

  onFormUpdate = (datasource, formName: string, values: any) => {

    if (values) {
      this.setState({values: {...values}, form: formName });
    }
  }

  render() {
    const formConfig = FormService.getCurrentFormConfig();
    if (!formConfig.sidebarContent) {
      return null;
    }    

    if (formConfig.sidebarForForm && formConfig.sidebarForForm != this.state.form) {
      return null;      
    }

    return <>
      {ReactHtmlParser(StringHelpers.replacePropertiesInString(formConfig.sidebarContent, this.state.values, true))}
    </>;
  }
}
